<script setup>
import { computed, inject } from 'vue'
import ObjectField from './ObjectField.vue'
import PasswordField from '../AdminControl/AdminControlPassword.vue'
import EntityField from './EntityField'
import CostsField from './CostsField'
import RolesField from './RolesField'
import FileUpload from './FileUpload.vue'
import ButtonWithDisplay from './ButtonWithDisplay.vue'
import StringSwitch from './StringSwitch.vue'
import {generateAPIKey} from "@/services/entityService"
import {resetMFAKey, disableUser} from "@/services/webservice"
import { useEntityRoute } from '@/composables/route/useListViewRoute'
import {useLogger} from "@/composables/useLogger"
import { useUserStore} from '@/store/user'
const { listViewTargetId } = useEntityRoute() 
const {sendLog} = useLogger()  
const userStore = useUserStore()

const props = defineProps({
  field: Object,
  modelValue: [String, Number, Boolean, Array, Object, null],
  path: {
    type: Array,
    default: () => []
  },
  drawerMode: String,
  itemName: String
})

const updateNestedValue = inject("updateNestedValue")
const entityState = inject("entityState")
const updateEntity = inject("updateEntity")

function updateChild(value) {
  const {path, field} = props
  sendLog("debug", "update_dynamicField_child_value", {path, field, value})
  if(field.label === "Organisation Name") {
    updateEntity("path", value)
    updateEntity("iden", value)
  }
  // if(field.label === "Organisation Name") updateEntity("pathPrefix", value)
  updateNestedValue(path, value)
}

const fieldComponentMap = {
  text: 'v-text-field',
  number: 'v-text-field',
  password: 'v-text-field',
  textarea: 'v-textarea',
  boolean: 'v-switch',
  select: 'v-select',
  multiselect: 'v-select',
  date: 'v-date-input',
  file: 'v-file-input',
  button: "v-btn"
}

const componentMap = {
  PasswordField,
  EntityField,
  FileUpload,
  ButtonWithDisplay,
  StringSwitch,
  RolesField,
  CostsField
}

const actionMap = {
  "generateAPIKey": () => actionMapWrapper(generateAPIKey, "generateAPIKey"),
  "resetMFAKey": () => actionMapWrapper(resetMFAKey, "resetMFAKey",{_id: listViewTargetId.value} ),
  "disableUser": () => actionMapWrapper(disableUser, "disableUser",{_id: listViewTargetId.value} )
}

const actionMapWrapper = async (func, mutationName, arg) => {
  const {data} = await func(arg)
  updateChild(data[mutationName])
}

const resolvedComponent = computed(() => {
    if (props.field.component) {
    return componentMap[props.field.component]
  }

  if (props.field.type === 'object') return ObjectField
  // if (props.field.type === 'array') return ArrayField
  
  return fieldComponentMap[props.field.type] || 'v-text-field'
})

function resolveReadonly(field) {
  if (typeof field.readonly === 'function') {
  return field.readonly(userStore.accesslevel, entityState) // add form state too ? 
  }
  return field.readonly ?? false
}

const safeValue = computed(() => {
  return props.modelValue ?? getDefaultValueForType(props.field.type)
  // return props.modelValue
})

function getDefaultValueForType(type) {

  switch(type) {

    case 'object':
      return {}

    case 'multiselect':
      return []

    case 'boolean':
      return false

    case 'number':
      return 0

    default:
      return ''
  }
}

const getFieldProps = (field) => {
  switch (field.type) {
    case 'select':
      return {
       items: field.items ?? [],
        itemTitle: field.itemTitle ?? 'label',
        itemValue: field.itemValue ?? 'value',
        multiple: field.multiple ?? false,
        clearable: field.clearable ?? false,
        chips: field.multiple ?? false,
        returnObject: field.returnObject ?? false
      }

    case 'number':
      return {
        type: 'number'
      }

    case 'password':
      return {
        type: 'password'
      }

    case 'boolean':
       return {
        inset: field.inset ?? true,
        trueValue: field.trueValue ?? true,
        falseValue: field.falseValue ?? false,
        color: field.color,
        density: field.density
      }
    
    case 'button':
      return { 
        onClick: actionMap[field.action]
      }
      case 'boolean-disable':
        return {
          "onDisable": actionMap["disableUser"],
        }
    default:
      return {}
  }
}
</script>

<template>
  <component
    :is="resolvedComponent"
    :label="field.label"
    :field="field"
    :model-value=safeValue
    :key="field.key"
    :drawerMode="drawerMode"
    density="compact"
    v-bind="{...getFieldProps(field), ...$attrs}"
    :path="[...path]"
    :readonly="resolveReadonly(field)"
    @update:modelValue="updateChild"
    :aria-label="field.label"
  >
  <template v-if="resolvedComponent === 'v-btn'">
    {{ field.label }}
    <v-text-field
      label="API Key"
      :model-value="123"
      readonly
    />
  </template>
  </component>
</template>